import { makeAutoObservable, runInAction } from "mobx";
import { IActionReasonField, IEmailAttachment, IRmaActionStore } from "../rma-types";

class RmaActionStore implements IRmaActionStore {
    private _isProcessing: boolean = false;

    constructor(private _actionCallback: () => void) {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get isProcessing(): boolean { return this._isProcessing; }

    public async submitAction(closeCb?: () => void) {
        try {
            this._isProcessing = true;
            await this._actionCallback();
            runInAction(() => {
                this._isProcessing = false;
                if (closeCb) {
                    closeCb();
                }
            });
        }
        catch (e) {
            runInAction(() => {
                this._isProcessing = false;
            });
        }    
    }

    /** stub methods required by interface interface */
    public get reasonField(): IActionReasonField | undefined { return undefined; }
    public get newReturnMethodId(): number | undefined { return undefined; }
    public get returnMethodWarning(): string | null { return null; }
    public get showReturnMethodChangeWarning(): boolean { return false; }
    public get sendEmailNotification(): boolean { return false; }
    public get emailAdditionalContent(): string | undefined { return undefined; }
    public get emailAttachments(): IEmailAttachment[] { return []; }
    public get restockingLocationId(): string|undefined { return undefined; }
    public setEmailAdditionalContent(v: string) {}
    public addEmailAttachment(attachment: IEmailAttachment): void {}
    public removeEmailAttachment(attachment: IEmailAttachment): void {}
    public resetReturnMethodChange() {}
    public confirmReturnMethodChange() {}
    public confirmReturnMethodsChangeWithLabelFees() {}
    public confirmReturnMethodsChangeWithoutLabelFees() {}
    public hasCustomerEmail(): boolean { return false; } 
    public setRestockingLocationId(v: string): void {}
    public setSelectedProductCaseIds(v: number[]): void {}
    public setSendEmailNotification(v: boolean): void {}
    public setNewReturnMethodId(v: number): void {}
}

export default RmaActionStore;